var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('manage-navegator'),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }